export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-500-d75cd71bdeec5133dec53cbaaa5b3913.ttf";